import { Inject } from '@angular/core';
import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Task } from 'src/app/model/sales/task.model';
import { Merchant } from 'src/app/model/sales/merchant.model';
import { AlertService } from 'src/app/service/alert.service';

@Component({
  selector: 'app-upload-dialog',
  templateUrl: './upload-dialog.component.html',
  styleUrls: ['./upload-dialog.component.scss']
})
export class UploadDialogComponent implements OnInit {

  public email: string = '';

  public files: Array<File> = new Array();

  public file!: File | undefined;

  public hasBaseDropZoneOver?: boolean;

  constructor(public dialogRef: MatDialogRef<UploadDialogComponent>,
              public alertService: AlertService,
              @Inject(MAT_DIALOG_DATA) public data: {type: string;
                                                     task: Task;
                                                     merchant: Merchant}) {
  }

  ngOnInit(): void {

    if (this.data
            .type === 'email' &&
        this.data
            ?.merchant
            ?.provisioning
            ?.owners[0]
            ?.email) {

      this.email = this.data
                       .merchant
                       .provisioning
                       .owners[0]
                       .email;
    }

  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public deleteFile(): void {
    this.file = undefined;
  }

  public getUploadType(): string {
    let type = '';

    switch (this.data.type) {
      case 'email':
        type = 'Link';
        break;
      case 'upload_menu':
        type = 'Menu';
        break;
      case 'upload_payment':
        type = 'Payment';
        break;
      case 'upload_training':
        type = 'Training';
        break;
      case 'upload_staff':
        type = 'Staff';
        break;
      case 'upload_layout':
        type = 'Layout';
        break;
      case 'upload_customer':
        type = 'Customer';
        break;
      case 'upload_inventory':
        type = 'Inventory';
        break;
    }

    return type;
  }

  public onFile(evt: any): void {

    if (evt.dataTransfer?.files?.length > 0
        && evt.dataTransfer?.files?.length <= 1) {
      this.file = evt.dataTransfer?.files[0];
    } else if (evt.target?.files?.length > 0) {
      this.file = evt.target.files[0];
    } else {
      this.alertService.error('Please, one file at a time.', evt);
    }
  }

  public onSend(): void {

    if (this.data.type === 'email'
        && this.data
              ?.merchant
              ?.provisioning
              ?.owners[0]
              ?.email) {

        this.dialogRef.close(this.email);
      } else {
        this.dialogRef.close(this.file);
      }
  }
}
